import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/')({
  loader: async ({ params: { org, roadmapId } }) => {
    // redirect to view route that will further redirect to first available view
    throw redirect({
      to: '/org/$org/roadmaps/$roadmapId/view',
      params: { org, roadmapId },
      replace: true,
    });
  },
});
